import VerifiedIcon from '@mui/icons-material/Verified';

export { QualityList } from './list';
export const QualityIcon = VerifiedIcon;
